// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"ax-z","smallCardRow":"bx-z","largeCardRow":"cx-z","productSearchRow":"dx-z","curatedRow":"ex-z"};